import Pin from "@components/cards/Pin";
import { GetPinsQuery } from "@typing/Generated";

type Props = {
  journeyId: string;
  pins: GetPinsQuery["pins"];
};

const Pins = ({ journeyId, pins }: Props) => (
  <div className="margin-20-top flex flex-column">
    {pins.map((pin, index) => (
      <Pin journeyId={journeyId} key={pin.id} noBorder={index === pins.length - 1} pin={pin} />
    ))}
  </div>
);

export default Pins;
